import { VENUE_RATINGS_ENABLED } from "../../config/meetingLocationFeatures";
import VenueRating from "../../components/meetingLocation/VenueRating";
import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { ArrowLeft, Heart, X } from "lucide-react";
import "./TeamPawsWalkFeedbackPage.css";
import apiClient from "../../api/apiClient";

import tablerBone from "../../assets/tabler_bone.png";
import mapDogPinIcon from "../../assets/dogHead.png";
import dogLevel0 from "../../assets/dogLevel5.png";
import dogLevel1 from "../../assets/dogLevel2.png";
import dogLevel2 from "../../assets/dogLevel4.png";

import TopNavBar from "../../components/TopNavBar";
import dogPlaceholder from "../../assets/dogPlaceholder.png";
import userPlaceholder from "../../assets/userPlaceholder.png";

const TeamSocialWalkFeedbackPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const sliderRef = useRef(null);
  const isDraggingRef = useRef(false);

  const { profile } = useSelector((state) => state.user);
  const [userDogStatus, setUserDogStatus] = useState(0);

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        if (profile?.id) {
          const res = await apiClient.get(`/user/details/${profile.id}`);
          if (res.data?.status && res.data.data) {
            setUserDogStatus(res.data.data.user_dog_status || 0);
          }
        }
      } catch (err) {
        console.error("Error fetching user:", err);
      }
    };
    fetchUserDetails();
  }, [profile?.id]);

  // slider: 0 = drop, 1 = sniff, 2 = take/pass
  const [sliderValue, setSliderValue] = useState(1);

  // viewState:
  // 0 = initial
  // 1 = sniff submitted
  // 2 = take/pass submitted
  const [viewState, setViewState] = useState(0);

  const [showTreatModal, setShowTreatModal] = useState(false);

  const feedbackOptions = [
    "I'd like to drop the leash\non this connection",
    "I'd like to keep sniffing\nout this connection",
    userDogStatus === 0
      ? 'Yes, I am ready to\n"Take the leash!"'
      : 'Yes, I am ready to\n"Pass the leash!"',
  ];

  const SLIDER_START = 12; // %
  const SLIDER_END = 88; // %
  const SLIDER_RANGE = SLIDER_END - SLIDER_START; // 90%
  const STEP_COUNT = 2; // 3 steps → 2 intervals
  const STEP_PERCENT = SLIDER_RANGE / STEP_COUNT; // 45%

  const thumbPosition = SLIDER_START + sliderValue * STEP_PERCENT;

  const dogLevelImages = {
    0: dogLevel0,
    1: dogLevel1,
    2: dogLevel2,
  };

  const getStepFromClientX = (clientX) => {
    const rect = sliderRef.current.getBoundingClientRect();
    const x = Math.min(Math.max(clientX - rect.left, 0), rect.width);
    const percent = (x / rect.width) * 100;

    const rawStep = Math.round((percent - SLIDER_START) / STEP_PERCENT);

    return Math.min(Math.max(rawStep, 0), 2);
  };

  const handleDragStart = (e) => {
    e.preventDefault();
    isDraggingRef.current = true;

    document.addEventListener("mousemove", handleDragMove);
    document.addEventListener("mouseup", handleDragEnd);
    document.addEventListener("touchmove", handleDragMove);
    document.addEventListener("touchend", handleDragEnd);
  };

  const handleDragMove = (e) => {
    if (!isDraggingRef.current) return;

    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    const step = getStepFromClientX(clientX);
    setSliderValue(step);
  };

  const handleDragEnd = () => {
    isDraggingRef.current = false;

    document.removeEventListener("mousemove", handleDragMove);
    document.removeEventListener("mouseup", handleDragEnd);
    document.removeEventListener("touchmove", handleDragMove);
    document.removeEventListener("touchend", handleDragEnd);
  };

  const handleSubmit = () => {
    if (sliderValue === 1) {
      setViewState(1);
    } else if (sliderValue === 2) {
      setViewState(2);
    }
  };

  const handleBack = () => {
    if (viewState !== 0) {
      setViewState(0);
    } else {
      navigate(-1);
    }
  };

  const handleGoToProfilePage = () => {
    // navigate("/");
  };

  const handleGoToBookingPage = () => {
    navigate("/team-social-availability");
  };

  return (
    <div className="feedback-container">
      {/* TOP NAV */}
      <div className="feedback-top-nav">
        <button className="back-nav-btn" onClick={handleBack}>
          <ArrowLeft size={24} color="#000" strokeWidth={3} />
          <span style={{ color: "rgba(0, 0, 0, 0.5)" }}>Back</span>
        </button>

        <div className="header-icons-right">
          <TopNavBar theme="light" />
        </div>
      </div>

      {/* MAIN CONTENT */}
      <div className="feedback-content">
        {/* TITLE */}
        <h1 className="feedback-title">
          {viewState === 0 && "HOW WAS YOUR WALK WITH  DIMSUM AND JEANETTE?"}

          {viewState === 1 && (
            <>
              DIMSUM & JEANETTE WOULD LIKE TO
              <br />
              BOOK ANOTHER GROUP WALK
            </>
          )}

          {viewState === 2 && (
            <>
              CONGRATULATIONS!
              <br />
              YOU HAVE UNLOCKED MILESTONE 2:
              <br />
              {userDogStatus === 0
                ? "TAKING THE LEASH WITH DIMSUM"
                : "PASSING THE LEASH FOR DIMSUM"}
            </>
          )}
        </h1>

        {/* PROFILE CARD (hidden only in state 3) */}
        {viewState !== 2 && (
          <div className="feedback-profile-card">
            <img src={userPlaceholder} alt="Angela" className="profile-img" />
            <div className="profile-overlay">
              <div className="profile-info-row">
                <Heart size={26} strokeWidth={2} />
                <span className="profile-name"></span>
                {/* <span className="profile-dist">2.5mi away</span> */}
              </div>
            </div>
          </div>
        )}

        {/* QUESTION TEXT */}
        <p
          className={`feedback-question ${
            viewState === 2 ? "feedback-question--state-2" : ""
          }`}
        >
          {viewState === 0 &&
            "Are you comfortable walking Dimsum on your own next time? "}

          {viewState === 1 && "Book your next walk with Dimsum!"}

          {viewState === 2 && (
            <>
              Book your next walk or playdate via the booking button in Dimsum’s
              profile!
            </>
          )}
        </p>

        {/* SLIDER (ONLY INITIAL STATE) */}
        {viewState === 0 && (
          <div className="feedback-slider-area" style={{ marginTop: "2rem" }}>
            <div className="slider-track-container-tpw" ref={sliderRef}>
              <div className="slider-track-bg-tpw"></div>
              <div
                className="slider-track-fill-tpw"
                style={{
                  // left: `${SLIDER_START}%`,
                  width: `${thumbPosition - SLIDER_START + SLIDER_START}%`,
                }}
              />

              {[0, 1, 2].map((step) => (
                <div
                  key={step}
                  className="slider-dot-wrapper"
                  style={{
                    left: `${SLIDER_START + step * STEP_PERCENT}%`,
                  }}
                  onClick={() => setSliderValue(step)}
                >
                  <div
                    className={`slider-dot ${
                      step <= sliderValue ? "active" : ""
                    }`}
                  />
                </div>
              ))}

              <div
                className="slider-thumb"
                style={{ left: `${thumbPosition}%` }}
                onMouseDown={handleDragStart}
                onTouchStart={handleDragStart}
              >
                <img
                  src={dogLevelImages[sliderValue]}
                  alt="Slider Dog"
                  style={{
                    width: sliderValue === 2 ? "70px" : "60px",
                    height: sliderValue === 2 ? "70px" : "60px",
                  }}
                />
              </div>
            </div>

            <div className="slider-labels-row">
              {feedbackOptions.map((text, index) => (
                <div
                  key={index}
                  className={`slider-label-item ${
                    index === sliderValue ? "selected" : ""
                  }`}
                  onClick={() => setSliderValue(index)}
                >
                  {text}
                </div>
              ))}
            </div>
          </div>
        )}

        {VENUE_RATINGS_ENABLED && (
        <VenueRating
          key={`${profile?.id}-${location.state?.location_id ?? "demo"}`}
          userId={profile?.id}
          locationId={location.state?.location_id}
        />
        )}

        {/* BUTTONS */}
        <div className="feedback-buttons-row">
          {viewState === 0 && (
            <>
              <button
                className="feedback-btn outline"
                onClick={() => setShowTreatModal(true)}
              >
                SHARE ADDITIONAL FEEDBACK
              </button>

              <button className="feedback-btn filled" onClick={handleSubmit}>
                SUBMIT
              </button>
            </>
          )}

          {viewState === 1 && (
            <button className="feedback-btn filled full-width">OKAY</button>
          )}

          {viewState === 2 && (
            <>
              <button
                className="feedback-btn filled"
                onClick={handleGoToProfilePage}
              >
                DIMSUM'S PROFILE
              </button>
              <button
                className="feedback-btn filled"
                onClick={handleGoToBookingPage}
              >
                BOOK DIMSUM
              </button>
            </>
          )}
        </div>
      </div>

      {/* MODAL */}
      {showTreatModal && (
        <div className="treat-modal-overlay">
          <div className="treat-modal-card">
            <button
              className="treat-close-btn"
              onClick={() => setShowTreatModal(false)}
            >
              <X size={16} strokeWidth={4} color="rgba(166, 28, 31, 1)" />
            </button>

            <div className="treat-modal-content">
              <div className="treat-icons-row">
                <div className="cb-treat-dog-avatar">
                  <img src={mapDogPinIcon} alt="dogIcon" />
                </div>
                <img src={tablerBone} alt="bone" style={{ width: "60px" }} />
              </div>

              <h3 className="treat-high-paw" style={{ marginBottom: "1rem" }}>
                HIGH PAW!
              </h3>

              <h2 style={{ fontSize: "1.5rem" }}>
                We will share your response with Dimsum & Jeanette to move you
                all forward on your dog-sharing journey!
              </h2>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TeamSocialWalkFeedbackPage;
